import flow from 'lodash/fp/flow';
import find from 'lodash/fp/find';
import get from 'lodash/fp/get';

import { productsCategories, productsSlugs } from './products';

/**
 * Categories
 */

export const subscriptionCategories = [productsCategories.HAIRCARE, productsCategories.SUPPLEMENTS];

/**
 * Coupons
 */

export const couponPercentage = 15;

/**
 * Frequencies
 */
export const defaultFrequency = 4;
export const frequencies = [
  { value: 4, label: 'Every month' },
  { value: 8, label: 'Every 2 months' },
  { value: 12, label: 'Every 3 months' },
];
frequencies[productsSlugs.SUPPLEMENT_CORE] = [frequencies[0]];
const recommendedFrequencies = [
  { value: 4, label: 'Every month (Recommended)' },
  { value: 8, label: 'Every 2 months (Recommended)' },
  { value: 12, label: 'Every 3 months (Recommended)' },
];
export const frequencyValues = frequencies.map(({ value }) => value);
export const getFrequencyLabelForValue = (value, recommendedValue = null) =>
  flow(
    find({ value }),
    get('label')
  )(recommendedValue === value ? recommendedFrequencies : frequencies);

/**
 * Quantities
 */

export const quantities = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
];

export const supplementsQuantities = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
];
